import { useRecoilValue, useSetRecoilState } from "recoil";
import { WizardStepProps } from "../../../CreateOrganisationWizard/CreateOrganisationWizard";
import { useAuth, useCurrentOrganisation, useOrganisation, useWalletConfigs } from "../../../../state/hooks/useAlignGovernance";
import { Fragment, useCallback, useEffect, useState } from "react";
import { getTokenAccountsByAddress } from "../../../../pages/Profile";
import { SCAM_MINTS } from "../../../../constants";
import { useConnection } from "@solana/wallet-adapter-react";
import { TOKEN_2022_PROGRAM_ID, getAssociatedTokenAddressSync, getMint } from "@solana/spl-token";
import { fetchMultiCoinPrice } from "../../../../api/token";
import { CheckIcon, ChevronUpDownIcon, ForwardIcon } from "@heroicons/react/24/outline";
import { proposalWizardSendAssetsRecipients, proposalWizardSendAssetsTokens } from "../../../../state/forms";
import { LAMPORTS_PER_SOL, PublicKey } from "@solana/web3.js";
import { BERN_MINT_ADDRESS, USDC_MINT_ADDRESS, getMetadataAccount, getMetadataAddress } from "align-sdk";
import { fetchNfts } from "../../../../api/nfts";
import { Listbox, Transition } from "@headlessui/react";
import { DebouncedFunc, constant, debounce } from "lodash";
import { truncateKey } from "../../../../utils/truncateKey";
import { amount } from "@metaplex-foundation/js";
import { toast } from "react-hot-toast";

const CoinComponent = ({
    amount,
    mint,
    onRecipient,
    recipients,
    price
}: {
    amount: number,
    mint: string,
    onRecipient : (id: number, amount: string) => void
    recipients: {
        id: number;
        walletAddress: string;
        name: string;
    }[], 
    price: number | null | undefined
}) => {

    const [selectedRecipients, setselectedRecipients] = useState<string[]>([]);
    const [name, setName] = useState<string| null>(null);
    const [image, setImage] = useState<string| null | undefined>(null)
    const [tokenAmounts, settokenAmounts] = useState<Record<string, string>>({});

    useEffect(() => {
        const fetchMetadata = async () => {
            try {
                if(mint === "11111111111111111111111111111111"){
                    setName("SOL")
                    setImage("/sol-logo.webp")
                    return
                }

                if(mint === USDC_MINT_ADDRESS.toBase58()){
                    setName("USDC")
                    setImage("/usdc-logo.webp")
                    return
                }

                if(mint === BERN_MINT_ADDRESS.toBase58()){
                    setName("BERN")
                    setImage("/bern.jpg")
                    return
                }
                
                const account = await fetchNfts([mint])
                if(account.length === 0){
                    return
                }
                setName(account[0]?.onChainMetadata?.metadata.data.name)
                setImage(account[0]?.offChainMetadata?.metadata.image)
            }
            catch(e){
               return 
            }
        
        }

        fetchMetadata()
    }, [mint]);


   
    const debounceFn = 
        useCallback<DebouncedFunc<(value : {amount : string, id : number}) => void>>(
             debounce((value : {amount : string, id : number}) => onRecipient(value.id, value.amount), 100), [])


    return (
        <li className="w-full bg-contrast bg-opacity-10 p-4 h-fit rounded flex flex-col gap-2">
            <div className="flex flex-col mb-2 md:mb-0 md:flex-row justify-between">

                <div className="flex gap-3 mb-2 md:mb-0 justify-center items-center">
                    <img className="rounded-full w-8 h-8" src={image || ""}/>
                    <div className="flex flex-col ">
                        <div className="flex gap-3 justify-start items-center ">
                            <div>{amount}</div>
                            <div className="text-xs font-light text-contrast text-opacity-70">${Math.floor((price || 0 * amount) * 100) / 100}</div>
                        </div>
                        <a target="_blank" href={`https://solana.fm/address/${mint}`} className="hover:cursor-pointer hover:text-opacity-60 text-xs text-accent text-opacity-20">{  mint !== "11111111111111111111111111111111" ? truncateKey(mint) : "~"}</a>
                    </div>
                 
                </div>
               
                <div className="flex gap-1 text-xs justify-center items-center font-light">
                <Listbox value={selectedRecipients} onChange={setselectedRecipients} multiple>
                <div className="relative mt-1">
                    <div className="flex gap-2 px-3 md:px-0 ">
                        <Listbox.Button className="relative md:w-full cursor-default rounded-lg bg-accent py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
                        <span className="block truncate">Select Recipients</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <ChevronUpDownIcon
                            className="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                        />
                        </span>
                        </Listbox.Button>
                        <div className="flex gap-1 justify-between items-center px-2 bg-accent w-[150px]">
                            <label>Amount</label> 
                            <img className="rounded-full w-6 h-6" src={image || ""}/>
                        </div>
                       
                    </div>
                
                <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-contrast py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                {recipients.map((person, personIdx) => (
                    <Listbox.Option
                    key={person.id}
                    className={({ active }) =>
                        `relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active ? 'bg-accent' : ' text-black'
                        }`
                    }
                    value={person.id}
                    >
                    {({ selected }) => (
                        <>
                        <span
                            className={`block truncate ${
                            selected ? 'font-medium' : 'font-normal'
                            }`}
                        >
                            {person.name}
                        </span>
                        {selected ? (
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                        ) : null}
                        </>
                    )}
                    </Listbox.Option>
                ))}
                </Listbox.Options>
            </Transition>
            </div>
        </Listbox>

                
                </div>
            </div>
            
            {
                selectedRecipients.map(sel => (
                    <div className="flex gap-2 justify-between md:justify-start items-center">
                        <div className="hidden md:flex md:flex-1"/>
                        <label className="bg-contrast bg-opacity-20 px-2 py-1 text-sm text-left">{recipients.find(x => x?.id as any  === sel)?.name}</label>
                        <div
                            className="relative z-0 flex justify-end items-center w-[100px] bg-transparent hover:border-accent active:border-accent active:outline-none border-contrast border-opacity-20 border text-sm h-8"
                
                        >
                            <input
                            className="absolute z-0 bg-transparent max-w-fit h-full w-full pl-2"
                            onChange={(e) =>{
                                let value = e.target.value
                                if(e.target.value[0] === "."){
                                    value = `0${e.target.value}`
                                }
                                var regex = /^\d+\.?\d*$/
                                if (regex.test(value) ){
                                    settokenAmounts(amounts => {
                                        amounts[sel] = value
                                        debounceFn({amount: value, id: Number(sel)})
                                        return amounts
                                    })
                                }
                            }} 
                            value={tokenAmounts[sel]}
                            />
                            <img className="rounded-full w-6 h-6 mr-2" src={image || ""}/>
                        </div>

                    </div>


                ))
            }
        </li>
    )
}

const ProposalWizardSendTokens = ({
    currentStep,
    onComplete
} : WizardStepProps<{}>) => {

    const user = useAuth()
    const setInputs = useSetRecoilState(proposalWizardSendAssetsTokens)
    const recipientInputs = useRecoilValue(proposalWizardSendAssetsRecipients)
    const [currentOrg] = useCurrentOrganisation()
    const {organisation} = useOrganisation(currentOrg)
    const {connection} = useConnection()
    
    const [tokens, settokens] = useState<{
        mint: string,
        quantity: number,
        decimals: number
    }[]>([]);

    const [prices, setprices] = useState<Record<string,{ value: number }>>({});
    const [tokenAmounts, settokenAmounts] = useState<Record<string, {recipient: string, amount: string, decimals: number}[]>>({});

    const areAmountsValid = (): boolean => {
        for (const mint in tokenAmounts) {
            const totalAmountForMint = tokenAmounts[mint].reduce((sum, tokenInfo) => sum + parseFloat(tokenInfo.amount), 0);
            
            const tokenBalance = tokens.find(token => token.mint === mint)?.quantity || 0;
            console.log(totalAmountForMint, tokenBalance)
            if (totalAmountForMint > tokenBalance) {
                return false
            }
        }
        return true;
    };

    const handleSubmit = (recipients : Record<string, {recipient: string, amount: string}[]> ) => {
        //Validations neeeds to be done heere
        if(!organisation?.wallets[0]?.walletAddress){
            return
        }
        if(!areAmountsValid()){
            toast.error("Balance exceeds what is available in the DAO treasury. Try reduce the amount of tokens.")
            return
        }
        
        
        setInputs(tokenAmounts)
        onComplete({})
    }

    useEffect(() => {
        const fetchTokens = async () => {
            try {
                const walletAddress = organisation?.wallets.find(x => x.name === "Treasury")?.walletAddress
                if(!walletAddress){
                    return
                }

                const tokenAccounts = await getTokenAccountsByAddress(walletAddress, connection)
                const token22Accounts = await getTokenAccountsByAddress(walletAddress, connection, TOKEN_2022_PROGRAM_ID)
                const nonScamNfts = [...token22Accounts.value, ...tokenAccounts.value].filter(acc => !SCAM_MINTS.includes(acc.account.data.parsed.info.mint))
                console.log(nonScamNfts)
                const tokens : {
                    mint: string,
                    quantity: number,
                    decimals : number
                }[] = nonScamNfts.map(token => ({
                    mint: token.account.data.parsed.info.mint,
                    quantity: token.account.data.parsed.info.tokenAmount.uiAmount,
                    decimals : token.account.data.parsed.info.tokenAmount.decimals
                }))
                const solBalance = await connection.getBalance(new PublicKey(walletAddress))
                tokens.sort((a,b) =>b.mint === USDC_MINT_ADDRESS.toBase58() || b.mint === "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263" ? 1 : -1)
                tokens.unshift({
                    mint: "11111111111111111111111111111111",
                    quantity: Math.floor(solBalance / 10000000) / 100,
                    decimals: 9
                })

                console.log(tokens)
                settokens(tokens)

                const prices = await fetchMultiCoinPrice([...tokens.map(x => x.mint), "So11111111111111111111111111111111111111112"])
                setprices(prices || {})
                console.log(prices)
                
                
            }
            catch(e){
                console.warn(e)
            }
        }
        fetchTokens()
    }, [organisation?.wallets, currentStep]);


    if(currentStep !== 2 ){
        return <></>
    }

    return ( 
        <div className="proposals-container relative box-container rounded-box border-contrast border-opacity-30 bg-opacity-30 w-full md:w-full p-6 lg:col-span-2 sm:p-6 bg-secondary border-boxWidth flex flex-col">
            <div className="font-heading text-lg md:text-3xl mb-2">Create Send Proposal </div>
            <h3 className="text-sm font-normal mb-6">Input or select recipients to send to</h3>

            <div className="w-full mb-3 h-96 p-4 proposals-container box-container bg-opacity-30 rounded-lg border-2 border-contrast border-opacity-30 flex-col justify-start  items-start gap-2.5 inline-flex">
                <h2 className="text-sm">SELECT FUNDIBLE TOKENS TO SEND</h2>
                <ol className="flex h-full flex-col gap-3 w-full overflow-auto scroll">
                    {tokens?.filter(x => x.decimals !== 0).map((tok, i) => (
                        <CoinComponent 
                            key={tok.mint}
                            amount={tok.quantity} 
                            onRecipient={(id, value) => settokenAmounts(amounts => {
                                const r = {
                                    recipient: id as any,
                                    amount : value,
                                    decimals: tok.decimals
                                }
                                if(amounts[tok.mint] === undefined){
                                    amounts[tok.mint] = [r]
                                }
                                const record  = amounts[tok.mint]?.find(x => x.recipient as any === id)
                                if(record){
                                    record.amount = value
                                    record.decimals = tok.decimals
                                    return amounts
                                }
                            
                                amounts[tok.mint] = [...amounts[tok.mint], r]
                                return amounts
                            })} 
                            recipients={recipientInputs || []}   
                            mint={tok.mint}
                            price={tok.mint !== "11111111111111111111111111111111" ? prices[tok.mint]?.value : prices["So11111111111111111111111111111111111111112"]?.value}                       
                            />

                    ))}
                </ol>
            </div>
            <button
                className="w-full flex justify-center gap-2 items-center mt-4 self-end bg-accent rounded-button border-primary  
                transition font-poppins font-medium p-3 text-sm px-5 py-2.5 text-center"
                
                onClick={() => handleSubmit(tokenAmounts)}
                >
                 <ForwardIcon className={`w-4 `}/>
                Next Step
            </button>
    </div>           
        
     );
}
 
export default ProposalWizardSendTokens;